import { render, staticRenderFns } from "./PaymentRequestBarNav.vue?vue&type=template&id=455bcf81&scoped=true&"
import script from "./PaymentRequestBarNav.vue?vue&type=script&lang=js&"
export * from "./PaymentRequestBarNav.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequestBarNav.vue?vue&type=style&index=0&id=455bcf81&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455bcf81",
  null
  
)

export default component.exports